import { gql, type TypedDocumentNode } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

import { CreateATeam } from './CreateATeam/index.tsx';
import { Hero } from './Hero/index.tsx';
import { LevelUp } from './LevelUp/index.tsx';
import { Navbar } from './Navbar/index.tsx';
import { OurCompetitions } from './OurCompetitions/index.tsx';
import { ScorePoints } from './ScorePoints/index.tsx';
import { ScoutAndCollect } from './ScoutAndCollect/index.tsx';
import { WinRewards } from './WinRewards/index.tsx';
import { YourBudget } from './YourBudget/index.tsx';
import type { HowToPlay_card } from './__generated__/index.graphql.ts';

const NavbarContainer = styled(Horizontal).attrs({ center: true })`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  width: 85%;
`;
export const HowToPlay = ({ cards }: { cards: HowToPlay_card[] }) => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <Vertical gap={0}>
      {!!isLaptopAndAbove && (
        <NavbarContainer>
          <Navbar />
        </NavbarContainer>
      )}
      <Hero cards={cards} />
      <ScoutAndCollect />
      <OurCompetitions />
      <CreateATeam />
      <ScorePoints card={cards[2]} />
      <WinRewards />
      <LevelUp />
      <YourBudget />
    </Vertical>
  );
};

HowToPlay.fragments = {
  card: gql`
    fragment HowToPlay_card on Card {
      slug
      ...Hero_card
      ...ScorePoints_card
    }
    ${Hero.fragments.card}
    ${ScorePoints.fragments.card}
  ` as TypedDocumentNode<HowToPlay_card>,
};
